import React from 'react';
export default function GlacialCrownSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="iceGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#E0F7FA" />
          <stop offset="100%" stopColor="#4FC3F7" />
        </linearGradient>
        <linearGradient id="frostShimmer" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="white" stopOpacity="0.6" />
          <stop offset="50%" stopColor="white" stopOpacity="0" />
          <stop offset="100%" stopColor="white" stopOpacity="0.4" />
        </linearGradient>
      </defs>

      {/* Crown base band */}
      <rect x="6" y="28" width="28" height="6" rx="2" fill="#4FC3F7" />
      <rect x="6" y="28" width="28" height="6" rx="2" fill="url(#frostShimmer)" />

      {/* Ice crystal spikes */}
      <polygon points="10,28 13,10 16,28" fill="url(#iceGrad)" />
      <polygon points="17,28 20,4 23,28" fill="url(#iceGrad)" />
      <polygon points="24,28 27,10 30,28" fill="url(#iceGrad)" />

      {/* Smaller side spikes */}
      <polygon points="6,30 8,18 10,30" fill="#B3E5FC" />
      <polygon points="30,30 32,18 34,30" fill="#B3E5FC" />

      {/* Frost highlight on spikes */}
      <polygon points="12,26 13,12 14,26" fill="white" opacity="0.35" />
      <polygon points="19,26 20,6 21,26" fill="white" opacity="0.35" />
      <polygon points="26,26 27,12 28,26" fill="white" opacity="0.35" />

      {/* Jewel accents at spike tips */}
      <circle cx="13" cy="10" r="1.5" fill="#E1F5FE" />
      <circle cx="20" cy="4" r="2" fill="#E1F5FE" />
      <circle cx="27" cy="10" r="1.5" fill="#E1F5FE" />

      {/* Sparkle particles */}
      <circle cx="9" cy="22" r="0.8" fill="white" opacity="0.7">
        <animate attributeName="opacity" values="0.3;0.9;0.3" dur="1.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="31" cy="24" r="0.6" fill="white" opacity="0.5">
        <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}
